import { useRef } from 'react'
import { useRequest } from 'ahooks'

import { Select } from 'antd'
import { Remark } from 'components'
import { Table } from '@sar/component'

async function fetchData (params, store) {
  const result = await store.externals.api.get(`/orders/purchase`, {
    params: Object.assign(params, {
      page: params.current,
      size: params.pageSize,
    })
  })

  return {
    success: true,
    data: result.data,
    total: result.totals,
  }
}

const isFinished = R.allPass([
    R.propEq('upMaterials', true)
  , R.propEq('upSplitQRCode', true)
  , R.propEq('upPurchase', true)
  , R.propEq('upPresent', true)
])

export default function ({ store, navigator }) {
  const columns = [
    {
      title: '序号',
      dataIndex: 'id',
    },
    {
      title: '客户姓名',
      dataIndex: 'customerName',
      formItemProps: () => ({ label: false }),
      fieldProps: () => ({ placeholder: '客户姓名' }),
    },
    {
      title: '联系电话',
      dataIndex: 'customerPhone',
      render: _ => _.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2'),
      formItemProps: () => ({ label: false }),
      fieldProps: () => ({ placeholder: '联系电话' }),
    },
    {
      title: '地址',
      dataIndex: 'customerAddress',
      formItemProps: () => ({ label: false }),
      fieldProps: () => ({ placeholder: '地址' }),
    },
    {
      title: '来源',
      dataIndex: 'customerSource',
    },
    {
      title: '来源',
      dataIndex: 'sourceId',
      valueType: 'treeSelect',
      hideInTable: true,
      request: () => store.externals.api.get(`/constant/source`),
      formItemProps: () => ({ label: false }),
      fieldProps: () => ({ fieldNames: { value: 'id', label: 'source' }, placeholder: '来源' }),
    },
    {
      title: '生产类型',
      dataIndex: 'type',
      valueType: 'select',
      valueEnum: store.config.getConstantEnums(`OrderType`),
    },
    {
      title: '项目单号',
      dataIndex: 'number',
    },
    {
      title: '文件上传',
      dataIndex: 'fileUpload',
      render: (_, data) => <a className='text-blue-600' onClick={() => navigator.to(`/placeorder/list/upload/${data.id}`, `文件上传`)}>{isFinished(data) ? '查看' : '上传'}</a>,
    },
    {
      title: '领料状态',
      dataIndex: 'materialsStatus',
      render: (_, data) => data.upMaterials ? '已领取' : '待领取',
    },
    {
      title: '是否到厂',
      dataIndex: 'presentStatus',
      render: (_, data) => data.upPresent ? '是' : '否',
    },
    {
      title: '负责人',
      dataIndex: 'producerName',
      render: (_, data, index, handles) => React.createElement(() => {
        const emps = useRequest<any, any>(() => store.externals.api.get(`/emp/all`), {
          cacheKey: `/emp/all`,
          staleTime: 3000,
        })

        const handleSave = useRequest(
          async id => store.externals.api.put(`/orders/purchase/${data.id}/producerName`, {
            producerId: id
          }),
          {
            manual: true
          }
        )

        if (store.identity.hasPermission('/placeorder/list:update') == false) {
          return _
        }

        return <Select
          className='w-32'
          defaultValue={data.producerId}
          options={emps.data?.map(elm => ({ value: elm.id, label: elm.nickname }))}
          onChange={handleSave.run}
        />
      })
    },
    {
      title: '更新时间',
      dataIndex: 'updateTime',
      valueType: 'date',
    },
  ]

  const cols = React.useMemo(() => {
    let showSearch = [
        'customerName'
      , 'customerAddress'
      , 'customerPhone'
      , 'sourceId'
    ]

    return columns.map(column => {
      if (showSearch.includes(column.dataIndex)) {
        return Object.assign(column)
      }

      else {
        return Object.assign(column, { hideInSearch: true })
      }
    })
  }, [])

  const rowActions = [
    {
      name: '下单',
      confirmType: 'modal',
      confirmMessage: '下单后订单会进入下一环节，将不可更改。',
      visible: () => store.identity.hasPermission('/placeorder/list:submit'),
      onConfirm: (data, handles) => store.externals.api.put(`/orders/purchase/${data.id}`).then(() => handles.current.reload()),
    },
    {
      name: '查看备注',
      form: props => <Remark {...props}/>,
    },
  ]

  return <div className='p-4'>
    <Table
      title='下单列表'
      columns={cols}
      rowActions={rowActions}
      request={params => fetchData(params, store)}
      search={{ labelWidth: 'auto', defaultCollapsed: true, span: Object.assign({}, store.config.responsive, { xxl: 4 }) }}
    />
  </div>
}
